/**
 * `config.js`
 *  -  設定ファイル
 *
 * 使用方法:
 *  - import { config } from "../config.js";
 */

export const config = {
  mode: 'prod',                 // dev or prod
  domainProd: 'ms-b.biz',       // 本番環境のドメイン
  useBarba: true,               // Barba.js を使うかどうか
  momentumScrolling: "lenis",   // "gsap" | "lenis" | "none"  (gsapはgsapScrollSmoother）
  useGsap: true,                // GSAP を使うかどうか
  useGsapScrollTrigger: true,   // GsapScrollTrigger を使うかどうか
  useThreeJS: false,            // Three.js を使うかどうか
  useSwiper: true,              // Swiper を使うかどうか（スライダー）
  useFlatpickr: true,           // Flatpickr を使うかどうか（日付選択モーダル）
  gaTagType: 'ga4',             // ga4 || gtm  GTMを使う場合は、GTM側のSPA設定を有効にするだけでOK。gaTagTypeをgtmにすることでJS側でのイベント送信を無効化できる。
  gaTagId:   'G-TFVT1EC254',    // プロジェクトのGTM, GA4アカウント
  recaptchaPublicKey: '6LejCyYeAAAAAL_kkUZNtgwi6PGIa6EySfvbMTRu', // reCAPTCHAの公開鍵（PHP側に秘密鍵もあるので変更等注意）// Recaptchaの使用 https://www.google.com/recaptcha/admin/
};
